class GroupedListWithTabs extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.groupedData = null;
    this.featuredData = null;
    this.featuredTitle = null;
    this.featuredButtonTitle = null;
    this.background = null;
  }

  static get observedAttributes() {
    return [
      "data",
      "featured",
      "featured-title",
      "featured-button-title",
      "background",
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data") {
      this.data = JSON.parse(newValue);
      this.groupedData = this.groupData(this.data);
    } else if (name === "featured") {
      this.featuredData = JSON.parse(newValue);
    } else if (name == "featured-title") {
      this.featuredTitle = newValue;
    } else if (name == "featured-button-title") {
      this.featuredButtonTitle = newValue;
    } else if (name == "background") {
      this.background = newValue;
    }
    this.render();
  }

  groupData(data) {
    return Object.values(
      data.reduce((result, item) => {
        const group = item.name[0].toUpperCase(); // Group by first letter
        if (!result[group]) {
          result[group] = { group, children: [item] };
        } else {
          result[group].children.push(item);
        }

        return result;
      }, {})
    );
  }

  render() {
    if (!this.groupedData || !Array.isArray(this.groupedData)) return;
    const className = `card ${this.background === "#ffffff" ? "white" : ""}`;

    // Tabs: Featured first, then grouped items by letter
    const tabsHTML = `
            <div class="grid">
                <div class="letter-list ${className}">
                   ${
                     this.featuredData
                       ? `
                    <div style="display: inline-flex;overflow:hidden;">
                        <a data-tab-index="featured" aria-selected="true" class="tab letters featured">${this.featuredButtonTitle}</a>
                    </div>
                    `
                       : ""
                   }
                    ${this.groupedData
                      .map(
                        (group, index) => `
                        <a data-tab-index="${index}" aria-selected="false" class="tab letters">${group.group}</a>
                    `
                      )
                      .join("")}
                </div>
        
                <div class="content ${className}">
                     ${
                       this.featuredTitle
                         ? `<h3 id="featured-title" >${this.featuredTitle}</h3>`
                         : ""
                     }
                    <div data-tab-index="featured" class="group">
                        ${this.featuredData
                          .map(
                            (item) => `
                            <a href="${item.link || "#"}" class="item">
                                <div class="flex-col">
                                    <img src="${item.image}" class="center">
                                    <h3 class="text--strong highlight center">${
                                      item.name
                                    }</h3>
                                </div>
                            </a>
                        `
                          )
                          .join("")}
                    </div>

                    ${this.groupedData
                      .map(
                        (group, index) => `
                        <div 
                            data-tab-index="${index}" 
                            class="group hidden"
                        >
                            ${group.children
                              .map(
                                (brand) => `
                                <a href="${
                                  brand.link || "#"
                                }" class="item" style='${
                                  brand.image ? "" : "justify-content: center; font-weight: 800"
                                }'>
                                    <div class="flex-col" 
                                    >
                                     ${
                                       brand.image
                                         ? `<img src="${brand.image}"><h3 class="text--strong highlight center">${brand.name}</h3>`
                                         : `<h3 class="text--strong highlight center">${brand.name}</h3>`
                                     }
                                    </div>
                                </a>
                            `
                              )
                              .join("")}
                        </div>
                    `
                      )
                      .join("")}
                </div>
            </div>
        `;

    // Set the shadow DOM inner HTML
    this.shadowRoot.innerHTML = `
            <style>
                .card {
                    background: var(--secondary-background);
                    border: 1px solid var(--border-color);
                }
                .card.white {
                   border: none;
                }

                .content {
                    padding: 2rem;
                }

                .content h3 {
                    color: var(--text-color);
                    font-weight: 500;
                }

                .letter-list {
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 20px;
                    padding: 1rem 0;
                    justify-content: center;
                    row-gap: 1rem;
                    position: relative;
                }
                .letter-list a {
                    margin-right: 10px;
                    cursor: pointer;
                    font-size: calc(var(--base-text-font-size) - (var(--default-text-font-size) - 21px));
                    text-decoration: none;
                    color: var(--text-color);
                }

            
                .letter-list a[aria-selected="true"]{
                    background-color: var(--text-color);
                    color: #fff;
                    border-color: var(--text-color);
                }

                .letters {
                    border: 1.5px solid var(--border-color);
                    width: 40px;
                    height: 25px;
                    margin-right: 9px;
                    line-height: 25px;
                    font-size: 12px;
                    text-align: center;
                }

                .letters:hover {
                    background-color: var(--text-color);
                    color: #fff;
                    border-color: var(--text-color);
                }

                .letters.featured {
                    padding: 0 1rem;
                    width: fit-content;
                    font-size:calc(var(--base-text-font-size) - (var(--default-text-font-size) - 21px));
                }

                .group {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
                    gap: 1rem;
                }
                .group-name {
                    font-weight: bold;
                    font-size: 1.2em;
                    margin-bottom: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                }

                .item {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    border: 1px solid #e9e9e9;
                    aspect-ratio: 1 / 1;
                    justify-content: end;
                    align-items: center;
                    height: max-content;
                }

                .item img {
                    mix-blend-mode: multiply;
                    margin: auto;
                    display: block;
                }
                .item h3 {
                    font-weight: var(--text-font-bolder-weight);
                    font-size: 100%;
                    color: var(--text-color);
                    margin: 0;
                    text-align: center;
                    fontw-weight: 900;
                }
                        
                a {
                    text-decoration: none;
                }
                .hidden {
                    display: none;
                }

                @media only screen and (max-width: 768px) {
                    .content {
                        padding: 1rem;
                    }
                    .group {
                        justify-content: space-between;
                        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));

                    }
                    .item {
                        min-width: 80px;
                    }
                    div:has(.featured) {
                        flex: 100%
                    }
                }

            </style>
            ${tabsHTML}
        `;

    // Add event listeners for tab switching
    this.shadowRoot.querySelectorAll(".tab").forEach((tab) => {
      tab.addEventListener("click", this.handleTabClick.bind(this));
    });
  }

  handleTabClick(event) {
    const index = event.target.getAttribute("data-tab-index");
    const isFeatured = index === "featured";

    const featuredTitleElement =
      this.shadowRoot.getElementById("featured-title");

    // Toggle the visibility of the featured title
    if (featuredTitleElement) {
      featuredTitleElement.classList.toggle("hidden", !isFeatured);
    }

    this.shadowRoot.querySelectorAll(".tab").forEach((tab) => {
      const tabIndex = tab.getAttribute("data-tab-index");
      tab.setAttribute("aria-selected", tabIndex === index);
      tab.classList.toggle("active", tabIndex === index);
    });

    this.shadowRoot.querySelectorAll(".group").forEach((group) => {
      const groupIndex = group.getAttribute("data-tab-index");
      group.classList.toggle("hidden", groupIndex !== index);
    });
  }
}

customElements.define("grouped-list-with-tabs", GroupedListWithTabs);